var components
try {
  components = {
    uIcon: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-icon/u-icon" */ "uview-ui/components/u-icon/u-icon.vue"
      )
    },
    uLoadingIcon: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-loading-icon/u-loading-icon" */ "uview-ui/components/u-loading-icon/u-loading-icon.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var s0 = _vm.__get_style([_vm.$u.addStyle(_vm.customStyle)])
  var l0 = _vm.previewImage
    ? _vm.__map(_vm.lists, function (item, index) {
        var $orig = _vm.__get_orig(item)
        var g0 =
          item.isImage || (item.type && item.type === "image")
            ? _vm.$u.addUnit(_vm.width)
            : null
        var g1 =
          item.isImage || (item.type && item.type === "image")
            ? _vm.$u.addUnit(_vm.height)
            : null
        return {
          $orig: $orig,
          g0: g0,
          g1: g1,
        }
      })
    : null
  var g2 =
    _vm.isInCount && !(_vm.$slots.default || _vm.$slots.$default)
      ? _vm.$u.addUnit(_vm.width)
      : null
  var g3 =
    _vm.isInCount && !(_vm.$slots.default || _vm.$slots.$default)
      ? _vm.$u.addUnit(_vm.height)
      : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        s0: s0,
        l0: l0,
        g2: g2,
        g3: g3,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }